module.exports = __webpack_public_path__ + "img/premium_03.1a02e889.png";